declare global {
  interface Window {
    isGtmGa4ClientReady?: boolean;
  }
}

/**
 * @description There is a tag in GTM that uses sequencing to run after Server GA4 Web client config
 *              tag is run. The tag will set `isGtmGa4ClientReady` global property, and
 *              emit a 'gtm-ga4-client-ready' event.
 * @tag_url https://tagmanager.google.com/?authuser=0#/container/accounts/2132319691/containers/8042077/workspaces/1000595/tags/942
 * @returns a promise that resolves when GA4 Web client is initialized
 */
export async function getGtmReadyPromise(): Promise<true> {
  if (window.isGtmGa4ClientReady) {
    return true;
  }

  return new Promise((resolve) => {
    document.addEventListener('gtm-ga4-client-ready', () => resolve(true));
  });
}
